import { api } from "@/api";
import { QueryConfig, QueryResult } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function isInitialMonetizacionSet(): Promise<boolean> {
    await sleep(1000);
    const response = await api.get("monetizacion/initial");
    return response.data;
}

export function useIsInitialMonetizacionSetQuery(queryConfig: QueryConfig<boolean> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await isInitialMonetizacionSet(),
        queryKey: ["monetizacion", "initial"],
    })
}

export interface IsInitialMonetizacionSetQueryProps {
    queryConfig?: QueryConfig<boolean>,
    children: (queryResult: QueryResult<boolean>) => ReactNode
}

export function IsInitialMonetizacionSetQuery({
    children,
    queryConfig
}: IsInitialMonetizacionSetQueryProps) {
    const queryResult = useIsInitialMonetizacionSetQuery(queryConfig);
    return children && children(queryResult);
}